import { formatDate } from '@startlibs/utils'
import { dateMessages } from './dateMessages'
import { getFileNameAndExtension, getUUID } from './common'
import {RecordClass, RecordFormat, RecordStatus} from './recordEnums'

const getType = recordClass => recordClass

export const isMultiFile = record =>
  [RecordFormat.Mirax, RecordFormat.HamamatsuVMS, RecordFormat.HamamatsuVMU].indexOf(
    record.recordFormat
  ) >= 0

export const isDicom = record => record.recordFormat === RecordFormat.DicomStudy

const canView = (recordClass, fileExtension) =>
  recordClass !== RecordClass.Other ||
  ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'pdf'].indexOf(
    (fileExtension || '').toLowerCase()
  ) >= 0

const getStatus = (state, quarantined) => {
  if (quarantined) return RecordStatus.Failed
  return RecordStatus.Uploaded
}

const getActions = (state, quarantined, hasMRN) => {
  if (hasMRN) {
    if (quarantined) {
      return 'delete'
    }
    if (state === RecordStatus.Uploaded) {
      return 'complete'
    }
    return 'readonly'
  }
  return 'none'
}

export const formatRecord = record => {
  const {
    recordClass,
    format,
    fileExtension,
    info: { description, studyUID, studyDescription },
    whenCreatedEpochMilli,
    recordUID,
    quarantined,
    state,
    originalFileName,
  } = record

  const status = getStatus(state, quarantined)

  return {
    name:
      studyDescription ||
      studyUID ||
      (isMultiFile({ recordFormat: format }) ? description : originalFileName),
    type: getType(recordClass, format),
    recordClass,
    recordFormat: format,
    date: formatDate(new Date(whenCreatedEpochMilli), 'L dd, yyyy', dateMessages, true),
    sortDate: whenCreatedEpochMilli,
    progress: null,
    status,
    showDialog: quarantined,
    dialogVariant: quarantined ? 'warning' : undefined,
    actions: getActions(state, quarantined),
    quarantined,
    studyUID,
    recordUID,
    viewEnabled: canView(recordClass, fileExtension),
    key: studyUID || recordUID,
  }
}

const DEFAULT_PATHOLOGY_METADATA = {
  External_Institution: '',
  Referring_Physician: '',
  Clinical_Diagnosis_and_History: '',
  Path_Case_Number: '',
  Stain: '',
  Part_Number_and_Description: '',
}

const getMetadata = recordClass =>
  recordClass === RecordClass.Pathology ? DEFAULT_PATHOLOGY_METADATA : undefined

export const createNewRecord = (name, recordClass, recordFormat, files, extraProperties = {}) => ({
  name,
  type: getType(recordClass, recordFormat),
  recordClass,
  recordFormat,
  files,
  metadata: getMetadata(recordClass),
  date: formatDate(new Date(), 'L dd, yyyy', dateMessages, true),
  sortDate: new Date(),
  progress: null,
  status: RecordStatus.Waiting,
  actions: 'delete',
  viewEnabled: canView(recordClass, getFileNameAndExtension(files[0].file)[1]),
  key: extraProperties.studyUID || getUUID(),
  ...extraProperties,
  params: {
    class: recordClass,
    format: recordFormat,
    ...extraProperties.params,
  },
})
